import { Module } from "vuex";
import { State } from "@/store/modules/page/state";
import Mutations from "@/store/modules/page/mutations";
import Getters from "@/store/modules/page/getters";
import Actions from "@/store/modules/page/actions";

export class Page implements Module<State, any> {
  namespaced: boolean = true;
  state: State;
  mutations = Mutations;
  getters = Getters;
  actions = Actions;

  // Setup CRUD operations
  constructor() {
    this.state = new State();
  }
}
